/**
 * Strings of the social feature of the next version (2026-10-29): rich
 * presence ("Playing X", Settings > Activity privacy), notes on profiles,
 * and Settings > Account > Account removal (Disable account, Delete
 * account). Discord's wording where Discord has one.
 */
import type { Dict } from './core';

export const nextSocialEn: Dict = {
  // ---- rich presence
  'nxs.act.title': 'Activity privacy',
  'nxs.act.status': 'Activity status',
  'nxs.act.share': 'Share my activity',
  'nxs.act.shareSub':
    "Show the game you're playing to people who can see you online. Turn it off and nobody sees it.",
  'nxs.act.games': 'Registered games',
  'nxs.act.now': 'Now playing',
  'nxs.act.none': 'No game detected',
  'nxs.act.offNote': "Sharing is off: others don't see your games.",
  'nxs.act.webOnly':
    "The desktop app detects the game you're playing. Here in the browser you see what others play, but your own games aren't detected.",
  'nxs.act.unsupported': "Game detection isn't available on this system.",
  'nxs.act.listHelp': {
    one: 'Games you play or add show here. {n} popular game is detected on its own.',
    other: 'Games you play or add show here. {n} popular games are detected on their own.',
  },
  'nxs.act.notSeeing': 'Not seeing your game?',
  'nxs.act.addIt': 'Add it!',
  'nxs.act.pick': 'Choose the program',
  'nxs.act.pickNone': 'No other program with a window is running. Start your game, then try again.',
  'nxs.act.nameLabel': 'Game name',
  'nxs.act.added': '{name} added to your games.',
  'nxs.act.running': 'Running',
  'nxs.act.hidden': 'Hidden',
  'nxs.act.custom': 'Added by you',
  'nxs.act.hide': 'Hide from my activity',
  'nxs.act.show': 'Show in my activity',
  'nxs.act.remove': 'Remove {name}',
  'nxs.act.playing': 'Playing {game}',
  'nxs.act.playingTitle': 'Playing a game',
  'nxs.act.elapsed': '{time} elapsed',
  'nxs.act.failed': "Couldn't reach the desktop app's game detection.",

  // ---- notes
  'nxs.note.title': 'Note',
  'nxs.note.placeholder': 'Click to add a note',
  'nxs.note.only': 'Only you can see this note.',
  'nxs.note.tooLong': 'A note can be up to 256 characters.',
  'nxs.note.add': 'Add note',
  'nxs.note.edit': 'Edit note',
  'nxs.note.failed': "Your note wasn't saved. Try again.",

  // ---- account removal
  'nxs.rm.title': 'Account removal',
  'nxs.rm.row': 'Disable or delete your account',
  'nxs.rm.sub':
    'Disabling your account means you can come back at any time by signing in. Deleting it is for good after 14 days.',
  'nxs.rm.disable': 'Disable account',
  'nxs.rm.delete': 'Delete account',
  'nxs.rm.disableBody':
    "Your account is turned off at once and you're signed out everywhere. Sign in again any time to turn it back on.",
  'nxs.rm.deleteBody':
    'Your account is disabled at once and deleted for good on {date}. Sign in before then to cancel. Your messages stay, shown as from a deleted account.',
  'nxs.rm.password': 'Password',
  'nxs.rm.code': 'Two-step code',
  'nxs.rm.codeHelp': 'A code from your authenticator app, or a recovery code.',
  'nxs.rm.wrongPassword': 'That password is wrong.',
  'nxs.rm.codeNeeded': 'Enter a code from your authenticator app or a recovery code.',
  'nxs.rm.wrongCode': "That code didn't work.",
  'nxs.rm.ownerTitle': 'Transfer ownership first',
  'nxs.rm.owner':
    'You own {server}. Transfer ownership in Server settings before you can disable or delete your account.',
  'nxs.ended.deletion':
    'Your account is set to be deleted on {date}. Sign in before then to keep it.',
  'nxs.ended.disabled': 'You disabled your account. Sign in to turn it back on.',
  'nxs.restored.deletion': "Welcome back! Your account won't be deleted.",
  'nxs.restored.disabled': 'Welcome back! Your account is on again.',
  // errorText's key for Discord's 40011
  'ns.err.40011': 'Transfer ownership of your server before you disable or delete your account.',
};
